import {ViewBase} from "@/rawdogjs/src/core/viewBase";
import {IView} from "@/rawdogjs/src/interfaces/IView";
import {LoadingPresenter} from "./loadingPresenter";
import {Router} from "@/rawdogjs/src/router";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";
import {UuidHelper} from "../../shared/IdentityHelper";

export class LoadingView extends ViewBase implements IView {

    public _presenter: LoadingPresenter;
    private _instanceId: string;


    constructor(viewName: string, router: Router, dependencyContainer: ParcelDependencyContainer, presenter: LoadingPresenter) {
        super(viewName, router, dependencyContainer);
        this._presenter = presenter;
        this._instanceId = UuidHelper.newId();
    }

    set title(title) {
        this.setTextById('title', title);
    }

    set body(body) {
        this.setTextById('body', body);
    }

    show(show) {
        const element = document.querySelector('#loading-view');
        (element as any).style.display = show ? 'block' : 'none';
    }

    setPresenter(presenter: LoadingPresenter) {
        this._presenter = presenter;
    }

    render(): void {
    }


}